package modysy.view

import org.scalajs.dom
import org.scalajs.dom.raw.HTMLElement

import scala.collection.mutable

/** Object providing images as HTMLElements for drawImage(...) calls. */
object ImageProvider {

  private val map = new mutable.HashMap[String, HTMLElement]

  /** Returns the image with the given name as an HTMLElement.
    * The returned image can be used inside drawImage(...).
    *
    * The image is searched as an .png image inside the img folder with the
    * given name as file name. Undefined behaviour is the result of an
    * image not found.
    *
    * The first time an image is returned it is created inside the document.
    * Additional calls with the same image name return the instance created
    * during the first call.
    *
    * @param name image file name without file extension
    * @return image as HTMLElement
    */
  def getImage(name: String): HTMLElement = {
    if (map.contains(name)) {
      map(name)
    } else {
      val elem = dom.document.createElement("img").asInstanceOf[HTMLElement]
      elem.setAttribute("src", "./src/img/" + name + ".png")
      map.+=(name -> elem)
      elem
    }
  }

  /** Returns a function usable to draw images.
    *
    * As the usage of drawImage with default values results
    * in errors with the coverage calculation this method can be used
    * to hide this problem.
    *
    * Signature of the function returned is:
    * (ctx: dom.CanvasRenderingContext2D, posX: Double, posY: Double) => Unit
    *
    * @param image  the image as HTMLElement to draw
    * @param width  the width of the image
    * @param height the height of the image
    * @return a function with ctx and position as arguments that draws the given image with the given size
    */
  def drawImgFnc(
      image: HTMLElement,
      width: Double,
      height: Double
  ): (dom.CanvasRenderingContext2D, Double, Double) => Unit = {
    (ctx: dom.CanvasRenderingContext2D, posX: Double, posY: Double) =>
      ctx.drawImage(image, posX, posY, width, height)
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/view/ImageProvider.scala